import { createRouter, createWebHistory } from 'vue-router';
import centerRoutes from './centerRoutes';
import mallRoutes from './mallRoutes';
import { getCookie } from '../assets/js/cookie'
import Center from '@/layout/center.vue';
// import Mall from '@/layout/mall.vue';

const router = createRouter({
  history: createWebHistory("/mall/"),
  routes: [
    {
      path: '/serveIndex',
      name: '农业“1+3”服务',
      component: () => import('@/view/otherPage/serveIndex.vue'),
      children: [
        {
          path: '', // 
          redirect: '/serveIndex/agroServe' // 重定向到国家级保真保质服务
        },
        {
          path: 'agroServe',
          name: '保真保质服务',
          component: () => import('@/components/other/agroServe.vue')
        },
        {
          path: 'customService',
          name: '金融及保险服务',
          component: () => import('@/components/other/customService.vue')
        },
        {
          path: 'financeAndinsure',
          name: '海关服务',
          component: () => import('@/components/other/financeAndinsure.vue')
        },
        {
          path: 'logisticsServe',
          name: '物流服务-便捷服务',
          component: () => import('@/components/other/logisticsServe.vue')
        },
        {
          path: 'lawServe',
          name: '法律服务',
          component: () => import('@/components/other/lawServeNew.vue')
        },{
          path: 'foreignTrade',
          name: '外贸服务',
          component: () => import('@/components/other/foreignTrade.vue')
        },
        {
          path: 'talentTraining',
          name: '人才及培训服务',
          component: () => import('@/components/other/talentTrainServe.vue')
        },
      ],
    },
    {
      name: '商城',
      path: '/',
      component: Center,
      children: mallRoutes
    },
    {
      path: '/Pdfcomp',
      name: 'pdf预览',
      component: () => import('@/view/pdf/Pdfcomp.vue')
    },
    {
      name: '首页',
      path: '/',
      component: Center,
      children: [
        {
          path: '',
          name: "/",
          component: () => import('@/components/dealSlide/slide'),
          children: centerRoutes,
        },
      ],
    },
    { name: '买家中心首页',
      path: '/',
      component: Center,
      children: [
        {
          path: '',
          name: "/",
          component: () => import('@/components/buyerCenter/slide'),
          children: centerRoutes,
        },
      ],
    },
    {
      name: '登录',
      path: '/login',
      component: () => import('@/view/user/login'),
    },
    {
      name: '注册',
      path: '/register',
      component: () => import('@/view/user/register'),
    },
    {
      name: '买家注册协议',
      path: '/userAgreement',
      component: () => import('@/view/user/userAgreement'),
    },
    {path: '/chatIndex',name: '聊天',component: () => import('@/components/chat/chatIndex')},
    {
      name: '外链接品种',
      path: '/varietiesLink',
      component: () => import('@/view/varieties/layout/center.vue'),
      children: [
        {
          path: '',
          name: '外链品种列表',
          component: () => import('@/view/varieties/index.vue')
        },
        {
          path: 'details',
          name: '外链品种详情页',
          component: () => import('@/view/varieties/details.vue')
        },
      ],
    },

    {
      name: '',
      path: '/oauth/login',
      component: () => import('@/view/user/oauth/login'),
    },
    // {
    //   name: '',
    //   path: '/test1',
    //   component: () => import('@/view/dealhome/test1.vue'),
    // },
    {
      path: '/goodsDetails',
      name: '首页-商品详情页',
      component: () => import('@/view/dealhome/goodsDetails.vue')
    },
  ],
  
  scrollBehavior() {
    return { top: 0 };
  },
});
router.beforeEach((to, from, next) => {
  next()
});


// createRouteGuard(router);
console.log(router,'router')
export default router;


